var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-16 marketing-container mx-auto w-full max-w-screen-2xl"},[_c('render-content',{staticClass:"gap-4 lg:gap-9 flex flex-wrap justify-left items-start",attrs:{"content":_vm.marketingCards}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }